// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/source/api/source_artifact.proto (package gx.source.api, syntax proto3)
/* eslint-disable */

import { SourceArtifactService } from "./source_artifact_pb.js";

/**
 * Artifact CRUD
 *
 * @generated from rpc gx.source.api.SourceArtifactService.CreateSourceArtifact
 */
export const createSourceArtifact = SourceArtifactService.method.createSourceArtifact;

/**
 * @generated from rpc gx.source.api.SourceArtifactService.GetSourceArtifact
 */
export const getSourceArtifact = SourceArtifactService.method.getSourceArtifact;

/**
 * @generated from rpc gx.source.api.SourceArtifactService.ListSourceArtifacts
 */
export const listSourceArtifacts = SourceArtifactService.method.listSourceArtifacts;

/**
 * @generated from rpc gx.source.api.SourceArtifactService.DeleteSourceArtifact
 */
export const deleteSourceArtifact = SourceArtifactService.method.deleteSourceArtifact;

/**
 * @generated from rpc gx.source.api.SourceArtifactService.DownloadSourceArtifact
 */
export const downloadSourceArtifact = SourceArtifactService.method.downloadSourceArtifact;
